//#region src/specs/mark-specs.ts
var e = {
	bold: {
		parseDOM: [
			{ tag: "strong" },
			{ tag: "b" },
			{
				style: "font-weight",
				getAttrs: (e) => /^(bold(er)?|[5-9]\d{2,})$/.test(e) && null
			}
		],
		toDOM() {
			return ["b", 0];
		}
	},
	italic: {
		parseDOM: [
			{ tag: "i" },
			{ tag: "em" },
			{ style: "font-style=italic" }
		],
		toDOM() {
			return ["i", 0];
		}
	},
	code: {
		parseDOM: [{ tag: "code" }],
		toDOM() {
			return ["code", 0];
		},
		inclusive: !1
	},
	anchor: {
		parseDOM: [{
			tag: "a",
			getAttrs(e) {
				return { href: e.getAttribute("href") ?? "" };
			}
		}],
		attrs: { href: { default: "" } },
		inclusive: !1,
		toDOM(e) {
			return [
				"a",
				{ href: e.attrs.href },
				0
			];
		}
	},
	underline: {
		parseDOM: [{ tag: "u" }],
		toDOM() {
			return ["u", 0];
		}
	},
	span: {
		parseDOM: [{
			tag: "span",
			getAttrs(e) {
				return { style: e.getAttribute("style") ?? "" };
			}
		}],
		attrs: { style: { default: "" } },
		toDOM(e) {
			return [
				"span",
				{ style: e.attrs.style },
				0
			];
		}
	},
	deletion: {
		parseDOM: [{ tag: "mark[data-mark-type=\"deletion\"]" }],
		toDOM() {
			return [
				"mark",
				{ "data-mark-type": "deletion" },
				0
			];
		},
		serializable: !1
	},
	insertion: {
		parseDOM: [{ tag: "mark[data-mark-type=\"insertion\"]" }],
		toDOM() {
			return [
				"mark",
				{ "data-mark-type": "insertion" },
				0
			];
		},
		serializable: !1
	}
};
//#endregion
export { e as markSpecs };
